import { Map } from 'immutable';
import actions from './actions';

const initState = new Map({
  therapist: null, clients:[], timezone:null, teamMembers:null, insuranceSettings:null,
  practiceDetails:null, billingSettings:null
});

export default function clientReducer(state = initState, action) {
  switch (action.type) {
    case actions.RESET_REDUCER:
      return initState;

    case actions.SET_CLIENTS:
      return state.set('clients', action.payload);
    case actions.SET_THERAPIST:
      return state.set('therapist', action.payload);
    case actions.SET_TIMEZONE:
      return state.set('timezone', action.payload);
    case actions.SET_TEAM_MEMBER:
      return state.set('teamMembers', action.payload);
    case actions.SET_INSURANCE_SETTING:
      return state.set('insuranceSettings', action.payload);
    case actions.SET_PRACTICE_DETAILS:
      return state.set('practiceDetails', action.payload);
    case actions.SET_BILLING_SETTING:
      return state.set('billingSettings', action.payload);
    default:
      return state;
  }
}
